import {
    httpGetUserEvents,
    HttpGetUserEventsOptions,
    HttpGetUserEventsResponse
} from '@/features/users/http/users.http.ts'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {useEffect, useState} from 'react'
import {QUERY_KEYS} from '@/queryClient.ts'
import {PaginationResponse} from '@/types.ts'

export const useGetUserEvents = (
    urlParams: HttpGetUserEventsOptions['urlParams'],
    params: HttpGetUserEventsOptions['params'],
    payload?: HttpGetUserEventsOptions['payload'],
    options?: Omit<UseQueryOptions<HttpGetUserEventsResponse>, 'queryKey' | 'queryFn'>
) => {
    const [persistedPagination, setPersistedPagination] = useState<PaginationResponse>({
        total: 0,
        lastPage: 1,
        perPage: 50,
        currentPage: 1
    })

    const query = useQuery({
        queryKey: [QUERY_KEYS.USER_EVENTS, urlParams, params, payload],
        queryFn: () => httpGetUserEvents({urlParams, params, payload}),
        ...options
    })

    useEffect(() => {
        if (query.isSuccess) {
            setPersistedPagination(query.data.meta)
        }
    }, [query.data?.data.length])

    return {...query, persistedPagination}
}
